import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import MenuIcon from "@mui/icons-material/Menu";
import Divider from "@mui/material/Divider";
import MuiDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import { styled } from "@mui/material/styles";
import * as React from "react";
import { useEffect, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import userInfo from "utils/userInfo";
import onoxologo from 'assets/img/fav.png'

import notes from 'assets/side_pane_new_icons/sticky.png'
import stylesB from "./MenuW.module.scss";
import stylesW from "./MenuW.module.scss";
import registration from "assets/side_pane_new_icons/createuser.svg";
import faq from "assets/side_pane_new_icons/faqin.svg";
import home from "assets/side_pane_new_icons/home.svg";
import task from "assets/side_pane_new_icons/note.svg";
import surveyicon from 'assets/side_panel_icons/6order.png'
import teams from "assets/side_pane_new_icons/team.svg";
import docs from "assets/side_pane_new_icons/document.svg";
import stream from "assets/side_panel_icons/5stream.png";

import project from "assets/side_pane_new_icons/project.svg";
import publication from "assets/side_panel_icons/publication.png";
import struc from "assets/side_pane_new_icons/building.svg";
import download from 'assets/side_pane_new_icons/downloadin.svg'
import table from "assets/side_panel_icons/tabel.png";
import money from 'assets/side_panel_icons/money.png'

//check color
const usertheme = userInfo()?.them;
let backgroundColor;
let textColor;
let invertLevel;
if (usertheme) {
  backgroundColor = "#f6f8f9";
  textColor = "#3a3a3a";
  invertLevel = "invert(0.8)";
} else {
  backgroundColor = "#f6f8f9";
  textColor = "#3a3a3a";
  invertLevel = "invert(0.8)";
}
const drawerWidth = "100%";

const openedMixin = (theme) => ({
  width: drawerWidth,
  borderRight: "unset",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  "& img": {
    width: "26px",
    height: "26px",
    marginBottom: "3px",
    filter: invertLevel,
  },
  "& p": {
    paddingLeft: "10px",
  },
});

const closedMixin = (theme) => ({
  transition: theme?.transitions.create("width", {
    easing: theme?.transitions.easing.sharp,
    duration: theme?.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  borderRight: "unset",
  height: "64px",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(7)} + 1px)`,
  },
  textAligh: "center",
  "& img": {
    width: "26px",
    height: "26px",
    marginBottom: "3px",
    filter: invertLevel,
  },
  "& p": {
    paddingLeft: "10px",
    marginBottom: "5px",
  },
});

const StyledDrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  borderRight: "unset",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": {
      ...openedMixin(theme),
      background: backgroundColor,
    },
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": {
      ...closedMixin(theme),
      background: "none",
    },
  }),
}));

export default function MenuDrawerMobile({ width }) {
  const [styles, setThem] = useState(stylesB);

  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const user = userInfo();

  const switchToStudy = localStorage.getItem("switchToStudy") === "true"

  useEffect(() => {
    if (user?.them) {
      setThem(stylesW);
    } else {
      setThem(stylesB);
    }
    localStorage.setItem("switchToStudy", switchToStudy);
  }, [switchToStudy]);


  const location = useLocation();
  return (
    <div className={styles.background_burger}>
      <Drawer variant="permanent" open={open}>
        <StyledDrawerHeader>
          {open ? (
            <div className={styles.logo__wrapper}><img className={styles.image_logo} src={onoxologo} /></div>
          ) : null}

          <IconButton
            className={styles.icon_button}
            sx={{ color: textColor, padding: "0 4px" }}
            aria-label="open drawer"
            onClick={() => setOpen((prevOpen) => !prevOpen)}
            edge="start"
          >
            {open ? <ChevronLeftIcon /> : <MenuIcon />}
          </IconButton>
        </StyledDrawerHeader>
        {open && (
          <>
            <Divider />
            <div className={styles.menu__list}>
              <List>
                <>
                
                  {user?.is_personal_kyrgyzkomur ? (
                  <ListItemButton
                    disablePadding
                    onClick={() => navigate(`/employee-card/`)}
                    style={
                      location.pathname.includes("employee-card")
                        ? { background: "rgb(188 182 182 / 34%)" }
                        : {}
                    }
                  >
                    <img className={styles.image_icon} src={home} alt="" />

                    {open ? <p>Главная</p> : null}
                  </ListItemButton>
                  ) : null}

                  {!user?.is_personal_kyrgyzkomur ? (
                  <ListItemButton
                    disablePadding
                    onClick={() => navigate(`/report-card/`)}
                    style={
                      location.pathname.includes("report")
                        ? { background: "rgb(188 182 182 / 34%)" }
                        : {}
                    }


                  >
                    <img src={table} alt="" />

                    {open ? <p>Перевозки</p> : null}
                  </ListItemButton>
                  ) : null}

                  {user?.is_admin_of ? (
                    <ListItemButton
                      disablePadding
                      onClick={() => navigate(`/adminpanel`)}
                      style={
                        location.pathname.includes("adminpanel")
                          ? { background: "rgb(188 182 182 / 34%)" }
                          : {}
                      }
                    >
                      <img className={styles.image_icon} src={task} alt="" />

                      {open ? <p>Админ панель</p> : null}
                    </ListItemButton>
                  ) : null}

                  {user?.is_admin_of ? (
                    <ListItemButton
                      disablePadding
                      onClick={() => navigate(`/register_person`)}
                      style={
                        location.pathname.includes("register_person")
                          ? { background: "rgb(188 182 182 / 34%)" }
                          : {}
                      }
                    >
                      <img className={styles.image_icon} src={registration} alt="" />

                      {open ? <p>Зарегистрировать</p> : null}
                    </ListItemButton>
                  ) : null}

                  {user?.is_report_of ? (
                    <ListItemButton
                      disablePadding
                      onClick={() => navigate(`/reports`)}
                      style={
                        location.pathname.includes("reports")
                          ? { background: "rgb(188 182 182 / 34%)" }
                          : {}
                      }
                    >
                      <img className={styles.image_icon} src={task} alt="" />

                      {open ? <p>Отчёты</p> : null}
                    </ListItemButton>
                  ) : null}

                </>
              </List>
            </div>
          </>
        )}
      </Drawer>
    </div>
  );
}
